import React, { useContext, useEffect, useRef, useState } from "react";
import RGBColorPicker from "./color-pickers/RGBColorPicker";
import "./Rgb.css";
import LinearSlider from "./Sliders/LinearSlider";
import { Context } from "../../../context/Context";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const RGB = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  data,
  setData,
}) => {
  const { equipmentButtons, devices } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [color, setColor] = useState({ r: 255, g: 255, b: 255 });
  const [brightness, setBrightness] = useState(100);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickChangeColor = (red, green, blue) => {
    setColor({ r: red, g: green, b: blue });
  };

  const handleChangeBrightness = (value) => {
    setBrightness(Number(value));
  };

  const handleSubmit = () => {
    const button = buttons[0];
    const device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
    if (button.digit == 0) {
      selectedChannel[selectedChannel.length - (Number(button.digit) + 1)] = "1";
      selectedChannel[selectedChannel.length - (Number(button.digit) + 2)] = "1";
      selectedChannel[selectedChannel.length - (Number(button.digit) + 3)] = "1";
    } else if (button.digit == 1) {
      selectedChannel[selectedChannel.length - (Number(button.digit) + 4)] = "1";
      selectedChannel[selectedChannel.length - (Number(button.digit) + 5)] = "1";
      selectedChannel[selectedChannel.length - (Number(button.digit) + 6)] = "1";
    }
    let data1 = parseInt(selectedChannel.join(""), 2);
    let data2 = button.digit == 0 ? color.r : 0;
    let data3 = button.digit == 0 ? color.g : 0;
    let data4 = button.digit == 0 ? color.b : 0;
    let data5 = button.digit == 1 ? color.r : 0;
    let data6 = button.digit == 1 ? color.g : 0;
    let data7 = button.digit == 1 ? color.b : 0;
    let data10 = button.digit == 0 ? brightness : 101;
    let data11 = button.digit == 1 ? brightness : 101;
    setData({
      icon: null,
      name: button.name,
      data: [
        2,
        data1,
        data2,
        data3,
        data4,
        data5,
        data6,
        data7,
        data10,
        data11,
      ],
      digit: Number(button.digit),
      device: device,
    });
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1rem" }}> */}
          <div className="rgb">
            <div className="text-center">
              <div>
                <p className="p-0 m-0 d-block">
                  {buttons?.[0]?.name}
                </p>
              </div>
              <div>
                <span style={{fontSize: '11px'}}>
                  C{buttons?.[0] ? buttons?.[0].digit + 1 : "-"}-S/
                  {buttons?.[0]
                    ? devices.find((d) => d.id == buttons?.[0]?.device_id)
                        ?.serial
                    : "-"}
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex flex-column">
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(0, 0, 0)}
                >
                  <img src="/assets/img/app-icons/zl.png" alt="" />
                </div>
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(255, 255, 255)}
                >
                  <img src="/assets/img/app-icons/v8.png" alt="" />
                </div>
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(255, 255, 0)}
                >
                  <img src="/assets/img/app-icons/_o.png" alt="" />
                </div>
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(255, 0, 255)}
                >
                  <img src="/assets/img/app-icons/hM.png" alt="" />
                </div>
              </div>
              <div>
                <RGBColorPicker
                  color={color}
                  setColor={handleClickChangeColor}
                />
              </div>
              <div className="d-flex flex-column">
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(255, 0, 0)}
                >
                  <img src="/assets/img/app-icons/gN.png" alt="" />
                </div>
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(0, 255, 0)}
                >
                  <img src="/assets/img/app-icons/gQ.png" alt="" />
                </div>
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(0, 0, 255)}
                >
                  <img src="/assets/img/app-icons/ht.png" alt="" />
                </div>
                <div
                  className="icons my-1"
                  onClick={() => handleClickChangeColor(0, 255, 255)}
                >
                  <img src="/assets/img/app-icons/hR.png" alt="" />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3">
              <div className="icons">
                <img src="/assets/img/app-icons/CE.png" alt="" />
              </div>
              <div className="slider">
                <LinearSlider
                  value={brightness}
                  setValue={(value) => handleChangeBrightness(value)}
                />
              </div>
              <div className="icons">
                <img src="/assets/img/app-icons/4W.png" alt="" />
              </div>
            </div>
          </div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(RGB);
